import React, {FC} from 'react';

import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {EmojiSearcher, SearchEmojiDefinition} from '../../../../store/stateless/emojiSelectors';
import {DropdownItemIconEmoji} from '../../dropdowns/dropdownItemIconEmoji';

/*
 * Constants.
 */

// HACK to avoid using a negative look-behind.
const partialEmojiRegExp = /(?:(?!\w).|^)(:([\w+-]{1,})(?::)?)$/;

/*
 * Props.
 */

interface EmojiEditorDropdownContentProps {
  emojiSearcher: EmojiSearcher;
  textBeforeCursor: string;
  getAnchor: (partialText: string) => DOMRectReadOnly | undefined;
  onEmojiSelect: (partialShortcode: string, searchEmoji: SearchEmojiDefinition) => void;
}

/*
 * Component.
 */

export const EmojiEditorDropdownContent: FC<EmojiEditorDropdownContentProps> = (props) => {
  const {emojiSearcher, textBeforeCursor, getAnchor, onEmojiSelect} = props;
  const partialEmojiMatch = textBeforeCursor.match(partialEmojiRegExp);
  if (!partialEmojiMatch) {
    return null;
  }

  const [, match, partialEmojiText] = partialEmojiMatch;
  if (!partialEmojiText || partialEmojiText.length < 2) {
    return null;
  }

  // Search for matching emojis.
  const emojis = emojiSearcher(partialEmojiText, 10);
  if (emojis.length === 0) {
    return null;
  }

  // Find the dropdown position.
  const anchor = getAnchor(partialEmojiText);
  if (!anchor) {
    return null;
  }

  // Render the dropdown.
  const emojiRenders = emojis.map((e) => (
    <DropdownItem key={e.matchingShortcode} onSelect={() => onEmojiSelect(match, e)}>
      <DropdownItemIconEmoji {...e} />
      <DropdownItemContent>{e.matchingShortcode}</DropdownItemContent>
    </DropdownItem>
  ));

  return (
    <SimpleDropdown anchor={() => anchor} maxWidth={260} shouldSelectFirst shouldSelectWithTab>
      {emojiRenders}
    </SimpleDropdown>
  );
};
